module.exports = __webpack_public_path__ + "static/media/49.675ed006.mp3";